import { ModuleErrorBoundary } from 'layout/module-load/module-error2.js';

export const AdvertErrorBoundary = ({
  adDisplayFalseCB,
  children,
}: {
  adDisplayFalseCB?: () => void;
  children: JSX.Element;
}): JSX.Element | null => {
  // Run when error occurs
  const handleError = (error: Error) => {
    console.warn('[ADVERT FUSE] error', error);
    adDisplayFalseCB?.();
    // Your custom error handling logic goes here.
  };

  return <ModuleErrorBoundary onError={handleError}>{children}</ModuleErrorBoundary>;
};
